import * as React from "react";
import i18next from "i18next";
import { ILayerState } from "../config";
import { MenuItem } from "./MenuItem";
import { useMapContext } from "../../Contexts/MapContext";
import { useLayersContext } from "../../Contexts/LayersContext";
import { GroupVisibility } from "../enums";
import "./TocWidget.scss";

export const TocWidget = ({ mainToc }: { mainToc: boolean }): JSX.Element => {
    const { layerStates } = useMapContext();
    const { setGroupVisibility, onToggle, showLayerMetadata } = useLayersContext();

    return (
        <div className="scrollable-content-container layerWidget esri-component esri-layer-list esri-widget esri-widget--panel">
            <ul className="scrollable-content esri-layer-list__list esri-layer-list__list--root esri-layer-list__list--independent">
                {layerStates.length ? (
                    layerStates
                        .filter((ls) => (mainToc ? !ls.showInMapDownloadWidget : ls.showInMapDownloadWidget))
                        .map((layer: ILayerState) => (
                            <MenuItem
                                key={layer.id}
                                layer={layer}
                                onToggle={onToggle}
                                onClickLayerMetadata={showLayerMetadata}
                                onClickGroupVisibility={(id: string, state: GroupVisibility) =>
                                    setGroupVisibility(id, state)
                                }
                            ></MenuItem>
                        ))
                ) : (
                    <div className="layers-loading">{i18next.t("isLoading")}</div>
                )}
            </ul>
        </div>
    );
};
